<portal-title-bar
  [title]="title"
  [filterControls]="filterControls"
  (filterChanged)="setGlobalFilterValues($event)"
  [displayControls]="displayControls"
  [chartTableToggle]="chartTableToggle"
  [chartDataPoints]="chartDataPoints"
  [fieldDefinitions]="fieldDefinitions"
  [showExportIcon]="true"
  [overrideExport]="overrideExport"
  [exportMenu]="exportChartMenu"
  (chartTableToggleChanged)="toggleChartTable($event)"
  (exportData)="overrideExportChartHandler()"
  class="CHART-TITLE-BAR chartTitlebarAppendTo"></portal-title-bar>

<div class="row {{ productId }}">
  <div class="col-md-12">
    <portal-accuracy-alert
      *ngIf="chartAccuracyForUI?.displayAccuracy"
      [type]="'warning'"
      [message]="chartAccuracyForUI?.message">
    </portal-accuracy-alert>
    <div class="elements mb-1 gap-3">
      <label
        *ngFor="let metricControl of metricControls; index as i"
        class="label-format me-1 me-md-2"
        [ngClass]="
          metricControl.control.displayOrder <= 10
            ? 'element-left'
            : 'element-right'
        ">
        <em
          *ngIf="metricControls.length > 1"
          class="pi pill"
          [ngStyle]="{ background: chartColors[metricControl.key] }"></em>
        {{ metricControl.control.label }}
        <div
          [class.benchmark-index-select]="
            isMeasuredBenchmarkLandingPage(dashboardLiteralId)
          ">
          <m-dropdown
            [options]="groupOptions"
            [group]="true"
            [filter]="true"
            filterBy="label"
            [(ngModel)]="selectedSeriesValues[metricControl.key]"
            (onChange)="seriesSelectionChanged(true)"
            optionLabel="label"
            optionDisabled="disabled"
            class="d-block"
            [appendTo]="chartTitlebarAppendTo"
            [panelStyleClass]="dashboardLiteralId"
            [customTemplate]="
              isMeasuredBenchmarkLandingPage(dashboardLiteralId)
                ? benchmarkItemTemplate
                : metricItemTemplate
            "
            [disabled]="chartDataLoading">
          </m-dropdown>
          @if (
            isMeasuredBenchmarkLandingPage(dashboardLiteralId) &&
              selectedSeriesValues[metricControl.key]?.specialLabel;
            as specialLabel
          ) {
            <div class="benchmark-index-select-label b1">
              <span class="benchmark-index-select-text">
                <span>{{ specialLabel.label }}</span
                ><span class="highlighted-label">{{
                  specialLabel.highlightedValue
                }}</span>
              </span>
            </div>
          }
        </div>

        <ng-template #benchmarkItemTemplate let-option>
          <div>
            {{ option.specialLabel.label }}
            <span class="highlighted-label">
              {{ option.specialLabel.highlightedValue }}
            </span>
          </div>
        </ng-template>

        <ng-template #metricItemTemplate let-metric>
          <div class="flex justify-between">
            {{ metric?.label }}
            @if (metric?.isTacticAtSpendModel) {
              <m-tooltip
                [content]="
                  'Tactics based on spend do not <br> have adjustment factors'
                "
                position="top"
                [tooltipOptions]="{
                  positionTop: -8,
                  positionLeft: 8,
                  tooltipStyleClass: 'm-tooltip',
                  tooltipZIndex: '10002',
                }">
                <span
                  class="material-symbols-outlined icon-small text-gray-500 ml-2"
                  [style]="{ pointerEvents: 'all' }">
                  info
                </span>
              </m-tooltip>
            }
          </div>
        </ng-template>
      </label>

      <div
        *ngIf="metricControls.length > 1"
        class="label-format ms-2 show-multiple-axes element-left mt-auto mb-2">
        <m-checkbox
          name="showMultipleAxis"
          [(ngModel)]="showMultipleAxes"
          [binary]="true"
          (onChange)="toggleMultipleAxes()"
          [disabled]="disableMultipleAxisCheckbox">
          Show Multiple Axes
        </m-checkbox>
      </div>

      <div
        *ngFor="let plotlineControl of plotlineControls"
        class="element-right">
        <label class="label-format show-filter"
          >{{ plotlineControl.control.label }}
          <p-inputNumber
            [(ngModel)]="
              currentPlotlineControlValues[plotlineControl.key.toString()].value
            "
            mode="decimal"
            (onBlur)="handleRoasChange($event, plotlineControl.key)"
            [minFractionDigits]="2"
            [maxFractionDigits]="5"
            step=".1"
            inputId="rinput"
            [inputStyle]="{ width: '8rem' }"
            class="d-block"
            [disabled]="chartDataLoading"></p-inputNumber>
        </label>
      </div>
      <div
        *ngFor="let childField of childrenControls"
        class="element"
        [ngClass]="'element-right'">
        <label class="ms-2 label-format"
          >{{ childField.label }}
          <m-multiselect
            *ngIf="childField.inputType === 'multiselect'"
            (onPanelHide)="updateChartSeriesControls(childField)"
            [(ngModel)]="childField.value"
            [options]="childField.options"
            [selectionLimit]="7"
            [width]="'140px'"
            [panelStyle]="{ maxWidth: '287px' }"
            placeholder="Select"
            selectedItemsLabel="{0} Selected"
            [maxSelectedLabels]="1"
            class="d-block">
          </m-multiselect>
        </label>
      </div>
      <div
        *ngFor="let field of filterFields"
        class="element d-flex flex-column"
        [ngClass]="field.position <= 10 ? 'element-left' : 'element-right'">
        <label
          *ngIf="field.inputType === 'select'"
          for="id-{{ field.name }}"
          class="label-format show-filter"
          >{{ field.label }}
        </label>
        <m-dropdown
          inputId="id-{{ field.name }}"
          *ngIf="field.inputType === 'select'"
          [ngClass]="[field.name, field.name === 'resolution' && 'capitalize']"
          [panelStyleClass]="
            field.name === 'resolution' ? 'capitalize' : field.name
          "
          [options]="field.options"
          [(ngModel)]="field.value"
          (onChange)="updateChartSeriesControls()"
          [disabled]="chartDataLoading"></m-dropdown>
      </div>
    </div>
    @if (showSpendModelBanner) {
      <div class="m-messages-wrapper my-8">
        <m-messages [messages]="messages"> </m-messages>
      </div>
    }
    <portal-empty-state [showMessage]="showEmptyState">
      <div
        [ngClass]="[
          'col-md-12',
          'chart-widget',
          hasCompare() ? 'chart-compare' : '',
        ]"
        *ngIf="chart"
        [chart]="chart"
        style="margin-top: 0.3rem"></div>
    </portal-empty-state>
  </div>
</div>

<div *ngIf="tableItem && tableData.length" class="row chart-data-table">
  <portal-data-grid-group
    [widgetLayout]="tableItem"
    [fieldDefinitions]="fieldDefinitions"
    [data]="tableData"
    [dataGridConfig]="dataGridConfig">
  </portal-data-grid-group>
</div>
